// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mi9AZ{width:100%;max-width:700px;height:280px;--signature-color: var(--text-on-standard-bg, var(--text-standard, #282863))}.mi9AZ.RHtv2{opacity:.6;pointer-events:none}.mSxsl{border-radius:8px;gap:16px;width:100%;height:100%;background-color:var(--bg-standard, #f3f5ff)}.eX8QR{flex:1;min-height:0;border-bottom:1px solid #bfbfd0;background:transparent}.i5rpX{flex:1;min-height:0;justify-content:flex-end}.i5rpX.kKkj8{display:none}.R5Oxm{flex:1;min-height:0}.Lf_YF{flex:0 0 auto}.V08yi{height:80px;font-family:"Satisfy",cursive;font-size:72px;font-weight:400;line-height:100%;text-align:left;padding-left:12px;padding-bottom:12px}.V08yi::placeholder{font-family:"Satisfy",cursive;font-size:72px;font-weight:400}.OSD_Z{background-color:transparent !important}.zmnkc{display:block;width:100%;min-height:80px;cursor:crosshair;touch-action:none;border:none;background:transparent}.oMYK7{align-items:center;justify-content:flex-end}.HNVad:disabled{opacity:.4}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"root": `mi9AZ`,
	"disabled": `RHtv2`,
	"signatureCard": `mSxsl`,
	"inputArea": `eX8QR`,
	"modePanel": `i5rpX`,
	"hidden": `kKkj8`,
	"modePanelContent": `R5Oxm`,
	"typeModePanelContent": `Lf_YF`,
	"signatureInputField": `V08yi`,
	"signatureInputRoot": `OSD_Z`,
	"canvas": `zmnkc`,
	"footer": `oMYK7`,
	"clearButton": `HNVad`
};
export default ___CSS_LOADER_EXPORT___;
